<template>
  <main class="article page-main">
    <section class="article-detail">
      <div class="article-detail-heading">
        <div class="article-detail-meta">
          <span class="article-detail-category" @click.prevent="goCategory">{{ $t('menuNewsroom.factCheck') }}</span>
          <time class="article-detail-date" :datetime="$moment(desserts.factPublishDate).format('YY.MM.DD')">{{ $moment(desserts.factPublishDate).format('YY.MM.DD') }}</time>
        </div>
        <div class="article-detail-title">
          <strong><html-view :value="desserts.factTitle | highlight($route.query.word)" /></strong>
          <small v-if="desserts.factSubTitle"><html-view :value="desserts.factSubTitle | highlight($route.query.word)" /></small>
        </div>
      </div>

      <loading v-if="loading" />

      <div v-else class="article-detail-content">
        <div v-if="desserts.summaries && desserts.summaries.length > 0" class="article-detail-summary">
          <ul v-for="item in desserts.summaries" :key="item.factSummarySeq">
            <li>{{ item.factSummaryContents }}</li>
          </ul>
        </div>

        <html-view :value="desserts.content | highlight($route.query.word)" class="editor" />
      </div>

      <div class="share-wrap">
        <share
          :seq="Number($route.params.newsroomId)"
          :title="desserts.factTitle"
          :type="'FACT'"
          :share-image="desserts.factImagePath"
        />
      </div>
    </section>

    <section v-if="desserts.previous || desserts.next" class="relate">
      <p class="relate-title">{{ $t('detail.wantNext') }}</p>
      <div class="relate-content">
        <div class="list list-default">
          <div v-if="desserts.previous" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, newsroomId : desserts.previous.factSeq}}">
              <!--              <div v-if="desserts.previous.reportImagePath" class="list-thumb"><img src="//via.placeholder.com/480x384"></div>-->
              <div class="list-cont">
                <p class="list-title">{{ desserts.previous.factTitle }}</p>
                <p v-if="desserts.previous.factSubTitle" class="list-desc">{{ desserts.previous.factSubTitle }}</p>
                <div>
                  <time class="list-date">{{ $moment(desserts.previous.factPublishDate).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
          <div v-if="desserts.next" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, newsroomId : desserts.next.factSeq}}">
              <!--              <div class="list-thumb"><img src="//via.placeholder.com/200x200"></div>-->
              <div class="list-cont">
                <p class="list-title">{{ desserts.next.factTitle }}</p>
                <p v-if="desserts.next.factSubTitle" class="list-desc">{{ desserts.next.factSubTitle }}</p>
                <div>
                  <time class="list-date">{{ $moment(desserts.next.factPublishDate).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="btn-wrap">
        <button type="button" class="btn" @click.prevent="goList">{{ $t('seeList') }}</button>
      </div>
    </section>
  </main>
</template>
<script>
import newsroomApi from '@/api/newsroom'
import contentDetail from '@/mixins/contentDetail'

export default {
  components: {
    share: () => import('@/components/base/Share'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [contentDetail],
  data () {
    return {
      desserts: {},
      loading: false
    }
  },
  watch: {
    '$route.params.newsroomId' () {
      this.getDetail()
    },
    '$route.params.locale' () {
      this.getDetail()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.$route.query.sharekey) {
      this.getShareDetail()
    } else {
      this.getDetail()
    }
  },
  methods: {
    async getDetail () {
      this.loading = true
      const { data } = await newsroomApi.getFactDetail(this.$route.params.newsroomId, {
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.setContents()
      }
      this.loading = false
    },
    async getShareDetail () {
      this.loading = true
      const { data } = await newsroomApi.getFactLink({
        linkKey: this.$route.query.sharekey,
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.setContents()
      }
      this.loading = false
    },
    goList () {
      if (this.$route.query.word) {
        this.$router.push({ name: 'NewsroomSearch', query: { ...this.$route.query } })
      } else {
        this.goCategory()
      }
    },
    goCategory () {
      this.$router.push({
        name: 'NewsroomFact',
        params: this.$route.params,
        query: { page: 1 }
      })
    }
  }
}
</script>
